import createRoute from '@widesk-ui/tools/createRoute';
import ClientModel from '@models/shop/ClientModel';

export default createRoute.splitView('/clients', 'shop', 'ClientSplitView', ClientModel.localize('plural'));
